import { Component, computed, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, RouterModule } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { lastValueFrom } from 'rxjs';
import { NewClientDialog } from '../../../features/client/new-client-dialog/new-client-dialog';
import { NewInstitutionDialog } from '../../../features/institution/new-institution-dialog/new-institution-dialog';
import { LvrPermissionDirective } from '../../../shared/permissions/permission.directive';
import { hasPermission } from '../../../shared/permissions/permission.func';
import { SessionManagerService } from '../../../shared/storage/session-manager.service';
import { BaseDestroy } from '../../components/base-destroy/base-destroy';
import { GlobalSearch } from '../../components/global-search/global-search';
import { RepresentationBanner } from '../../components/representation-banner/representation-banner';
import { Sidebar } from '../../components/sidebar/sidebar';
import { SidebarButton } from '../../components/sidebar/sidebar-button';
import { REPRESENTATION_MODE } from '../../services/representation-mode.service';
import { BasicLayoutComponent } from '../basic-layout/basic-layout';
import { BasicLayoutHeaderComponent } from '../basic-layout/basic-layout-header';
import { BasicLayoutLeftComponent } from '../basic-layout/basic-layout-left';
import { BrandingService } from '../../services/branding.service';
import { LvrButton } from '../../components/lvr-button/lvr-button';

@Component({
	selector: 'lvr-default-layout',
	standalone: true,
	imports: [
		RouterModule,
		Sidebar,
		BasicLayoutComponent,
		BasicLayoutHeaderComponent,
		BasicLayoutLeftComponent,
		SidebarButton,
		GlobalSearch,
		RepresentationBanner,
		LvrPermissionDirective,
		TranslocoPipe,
		LvrButton,
	],
	templateUrl: './default-layout.html',
	styleUrl: './default-layout.scss',
})
export class DefaultLayout extends BaseDestroy {
	private readonly dialog = inject(MatDialog);
	private readonly session = inject(SessionManagerService);
	private readonly representationMode = inject(REPRESENTATION_MODE);
	private readonly brandingService = inject(BrandingService);
	private readonly router = inject(Router);
	public readonly logo = computed(() => this.brandingService.branding().logo);
	public readonly isRepresentationActive = this.representationMode.isActive;
	public readonly canCreateClientsPermission = hasPermission(this.session.permissions, 'Clients.Create');
	public readonly canCreateClientsPhaseOneOnlyPermission = hasPermission(
		this.session.permissions,
		'Clients.Create.PhaseOneOnly',
	);

	public async openNewInstitutionDialog() {
		const dialogRef = this.dialog.open(NewInstitutionDialog, { width: '40vw' });
		await lastValueFrom(dialogRef.afterClosed());
	}

	public async openNewClientDialog() {
		const dialogRef = this.dialog.open(NewClientDialog, { width: '40vw' });
		await lastValueFrom(dialogRef.afterClosed());
	}

	public readonly canCreateClients = computed(() => {
		return (
			this.canCreateClientsPermission() ||
			(this.isRepresentationActive() && this.canCreateClientsPhaseOneOnlyPermission())
		);
	});

	public goToWiki() {
		this.router.navigate(['/wiki']);
	}
}
